import { get } from '../services/common/common.service';
import { eBillingActivityEndPoints } from '../constants/endpoint';

export const fetchEBillingActivityCPI = (payload) => {
  return get(
    `${eBillingActivityEndPoints.getEntitlementsBillingActivityCPI}?entitlementId=${payload.entitlementId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`
  );
};

//Fetch Billing Acitivity - Billing Tab Grid Data
export const fetchEBillingActivityBilling = (payload) => {
  return get(
    `${eBillingActivityEndPoints.getEntitlementBillingActivityBilling}?entitlementId=${payload.entitlementId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`
  );
};